var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8BA6C1",
    d: "M12.648 5.01c.78 0 3.143.17 4.564 2.305l.333.5-.479.361c-.684.517-1.933 1.459-1.933 3.325 0 2.21 1.414 3.06 2.094 3.468.3.18.61.366.61.773 0 .266-2.12 5.97-5.2 5.97-.753 0-1.285-.226-1.755-.426-.475-.202-.885-.376-1.563-.376-.343 0-.777.162-1.237.334-.629.235-1.34.501-2.147.501h-.02C2.677 21.727 0 15.12 0 11.755 0 6.26 4.124 5.057 5.713 5.057c.716 0 1.48.282 2.155.53.471.174.96.353 1.23.353.163 0 .545-.152.883-.286.72-.287 1.617-.643 2.661-.643h.006zm.32-5.01c.08 2.891-1.987 4.897-4.053 4.771C8.575 2.464 10.98 0 12.968 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppstore);
export default __webpack_public_path__ + "static/media/appstore.d919af00ee208377ed3b6379ba17a629.svg";
export { ForwardRef as ReactComponent };